import {
  AGENDA,
  CHANGE_PASSWORD,
  CHAT,
  COURSES,
  MENTORSHIP,
  EVENTS,
  FEED,
  FORGOT_PASSWORD,
  LOGIN,
  PROFILE,
  SIGNUP,
  SETTINGMODULE,
  WEBINAR,
  EDIT_PROFILE,
  NOTIFICATIONS,
  SEARCH,
  EVENT_DETAILS,
  WEBINAR_PAGE_DETAILS,
  SESSION_PAGE_DETAILS,
  MyReports,
  PROFILEEVENTS,
  LIVE_WEBINARS,
  PROFILEPOSTS,
  GROUPSETTING,
  CONTESTS,
  CONTEST_DETAILS,
  CLINICAL_SESSIONS,
  CLINICAL_SESSIONS_DETAILS,
  POST_DETAILS,
  POLL_DETAILS,
  WEBINAR_DETAILS,
  CLINICAL_DETAILS,
  CLINICAL_SESSION_DETAILS,
  CONTEST_LIST,
  NEW_CONTEST,
  COURSE_SHARED_POST,
  EVENT_SHARED_POST,
  SEE_ALL_TRENDING_PAGE,
  SEE_ALL_FOLLOWING_DOCTOR_PAGE,
  SEE_ALL_POPULAR_COURSES_PAGE,
  NEW_COURSE_DETAILS,
  SEE_ALL_SUGGESTED_EVENTS,
  WALLET,
  payPalCallback,
  PAYPAL_PAYMENT,
  COURSE_CHAPTER_DETAILS,
  Chapter_Quiz,
  NEW_COURSE_DETAIL_PAGE,
  COURSE_COMMUNITY,
  COURSE_COMMUNITY_LIST,
  DOCTOR_ACCOUNT,
  FACILITY_ACCOUNT,
  INDUSTRY_ACCOUNT,
  NEW_LOGIN,
  NEW_SIGNUP,
  MANAGE_PROFILE,
  MANAGE_FACILITY,
  MANAGE_INDUSTRY,
  NEW_PROFILE_DOCTOR,
  NEW_PROFILE_FACILITY,
  NEW_PROFILE_INDUSTRY,
} from "./RoutesUrl";
import LoggedInRoute from "./LoggedInRoute";
import ProtectedRoute from "./ProtectedRoute";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy } from "react";
import Loadable from "../components/common/Loadable";
import CourseCommunityList from "../components/courses/NewCourse/CourseCommunityList";

import Feed from "../pages/Feed";
import Agenda from "../pages/agenda/Agenda";
import Courses from "../pages/course/Courses";
import Mentorship from "../components/Mentorship/Mentorship";
import Events from "../pages/Events";
import Search from "../pages/search/Search";
import DoctorsSearch from "../pages/search/DoctorsSearch";
import PostsSearch from "../pages/search/PostsSearch";
import WebinarsSearch from "../pages/search/WebinarsSearch";
import ClinicalStudiesSearch from "../pages/search/ClinicalStudiesSearch";
import CoursesSearch from "../pages/search/CoursesSearch";
import EventsSearch from "../pages/search/EventsSearch";
import ContestSkeleton from "../components/sponsor-post/ContestSkeleton";

const Profile = Loadable(lazy(() => import("../pages/Profile")));
const ChatModule = Loadable(lazy(() => import("../pages/chat/ChatModule")));
const SettingModule = Loadable(lazy(() => import("../pages/setting/SettingModule")));
const EditProfileInfo = Loadable(lazy(() => import("../pages/setting/EditProfileInfo")));
const Index = Loadable(lazy(() => import("../pages/notifications/Index")));
const EventsDetails = Loadable(lazy(() => import("../pages/events/EventsDetails")));
const WebinarDetails = Loadable(lazy(() => import("../pages/webinar/WebinarDetails")));
const SessionDetails = Loadable(lazy(() => import("../pages/clinical-sessions/SessionDetails")));
const MentorshipSessionDetails = Loadable(lazy(() => import("../pages/mentorship/MentorshipSessionDetails")));
const CreateComplaint = Loadable(lazy(() => import("../components/manage_account/Create_Complaint")));
const ProfileEvents = Loadable(lazy(() => import("../components/events/ProfileEvents")));
const LiveWebinars = Loadable(lazy(() => import("../components/live-webinars/LiveWebinars")));
const ProfilePost = Loadable(lazy(() => import("../components/feeds/cards/ProfilePost")));
const GroupSettings = Loadable(lazy(() => import("../pages/GroupSetting/GroupSettings")));
const Contest = Loadable(lazy(() => import("../pages/sponsor-post/Contest")), <ContestSkeleton />);
const ContestDetail = Loadable(lazy(() => import("../components/sponsor-post/ContestDetail")), <ContestSkeleton />);
const ClinicalSessions = Loadable(lazy(() => import("../pages/clinical-sessions/ClinicalSessions")));
const ClinicalSessionsDetails = Loadable(lazy(() => import("../pages/clinical-sessions/ClinicalSessionsDetails")));
const PostsDetails = Loadable(lazy(() => import("../pages/post-details/PostsDetails")));
const ContestList = Loadable(lazy(() => import("../components/sponsor-post/ContestList")), <ContestSkeleton />);
const NewContest = Loadable(lazy(() => import("../components/sponsor-post/NewContest")), <ContestSkeleton />);
const CourseSharedPost = Loadable(lazy(() => import("../pages/post-details/CourseSharedPost")));
const EventSharedPost = Loadable(lazy(() => import("../pages/post-details/EventSharedPost")));
const SeeAllCoursesPage = Loadable(lazy(() => import("../components/courses/See-All-Components/SeeAllCoursesBasePage")));
const NewCourseDetail = Loadable(lazy(() => import("../components/course-details/NewCourseDetail")));
const SeeAllSuggestedEvents = Loadable(lazy(() => import("../pages/events/see-all-events/SeeAllSuggestedEvents")));
const Wallet = Loadable(lazy(() => import("../pages/setting/wallet/Wallet")));
const PayPalCallback = Loadable(lazy(() => import("../pages/setting/wallet/PayPalCallback")));
const PaypalPaymentPage = Loadable(lazy(() => import("../components/course-details/PaypalPaymentPage")));
const CourseChapterDetails = Loadable(lazy(() => import("../components/course-details/course-content-details/CourseChapterDetails")));
const ChapterQuiz = Loadable(lazy(() => import("../pages/ChapterQuiz")));
const CourseSearchResultPage = Loadable(lazy(() => import("../pages/course/CourseSearchResultPage")));
const NewCourseDetailPage = Loadable(lazy(() => import("../components/courses/NewCourse/NewCourseDetail2.0")));
const CourseCommunity = Loadable(lazy(() => import("../components/courses/NewCourse/CourseCommunity")));
const DoctorManageAccount = Loadable(lazy(() => import("../components/manage_account/new_manage_account/doctor_manage_account/page")));
const FacilityManageAccount = Loadable(lazy(() => import("../components/manage_account/new_manage_account/facility_manage_account/page")));
const IndustryManageAccount = Loadable(lazy(() => import("../components/manage_account/new_manage_account/industry_manage_account/page")));
const NewProfileForgotPassword = Loadable(lazy(() => import("../pages/auth/newauth/newProfiles/ForgotPassword")));
const NewProfileResetPassword = Loadable(lazy(() => import("../pages/auth/newauth/newProfiles/ResetPassword")));
const NewProfileLogin = Loadable(lazy(() => import("../pages/auth/newauth/newProfiles/Login")));
const DoctorProfilePage = Loadable(lazy(() => import("../pages/auth/newauth/newProfiles/Doctor/DoctorProfilePage")));
const FacilityProfilePage = Loadable(lazy(() => import("../pages/auth/newauth/newProfiles/Facility/FacilityProfilePage")));
const IndustryProfilePage = Loadable(lazy(() => import("../pages/auth/newauth/newProfiles/Industry/IndustryProfilePage")));
const ProfileRedirect = Loadable(lazy(() => import("../components/common/ProfileRedirect")));
const NewProfile = Loadable(lazy(() => import("../pages/DoctorProfile/NewProfile")));
const NewFacilityProfile = Loadable(lazy(() => import("../pages/FacilityProfile/NewFacilityProfile")));
const NewIndustryProfile = Loadable(lazy(() => import("../pages/IndustryProfile/NewIndustryProfile")));
const WaitingScreen = Loadable(lazy(() => import("../pages/auth/newauth/WaitingScreen")));
const AgainVerification = Loadable(lazy(() => import("../pages/auth/newauth/AgainVerification")));
const AccountReject = Loadable(lazy(() => import("../pages/auth/newauth/AccountReject")));

const Router = createBrowserRouter([
  { path: LOGIN, element: <LoggedInRoute><NewProfileLogin /></LoggedInRoute> },
  { path: SIGNUP, element: <LoggedInRoute><NewProfileLogin initialShowSignup /></LoggedInRoute> },
  { path: "/search/doctors", element: <ProtectedRoute><DoctorsSearch /></ProtectedRoute> },
  { path: "/search/posts", element: <ProtectedRoute><PostsSearch /></ProtectedRoute> },
  { path: "/search/webinars", element: <ProtectedRoute><WebinarsSearch /></ProtectedRoute> },
  { path: "/search/clinicals", element: <ProtectedRoute><ClinicalStudiesSearch /></ProtectedRoute> },
  { path: "/search/courses", element: <ProtectedRoute><CoursesSearch /></ProtectedRoute> },
  { path: "/search/events", element: <ProtectedRoute><EventsSearch /></ProtectedRoute> },
  { path: MyReports, element: <ProtectedRoute><CreateComplaint /></ProtectedRoute> },
  { path: PROFILE + "/:id", element: <ProtectedRoute><ProfileRedirect /></ProtectedRoute> },
  {
    path: FORGOT_PASSWORD,
    element: <LoggedInRoute><NewProfileForgotPassword onBack={() => window.history.back()} onBackToLogin={() => window.location.replace('/')} /></LoggedInRoute>,
  },
  {
    path: CHANGE_PASSWORD,
    element: <LoggedInRoute><NewProfileResetPassword onBackToLogin={() => window.location.replace('/')} /></LoggedInRoute>,
  },
  { path: FEED, element: <ProtectedRoute><Feed /></ProtectedRoute> },
  { path: AGENDA, element: <ProtectedRoute><Agenda /></ProtectedRoute> },
  { path: AGENDA + "/:id", element: <ProtectedRoute><Agenda /></ProtectedRoute> },
  { path: EVENTS + "/:id", element: <ProtectedRoute><Events /></ProtectedRoute> },
  { path: PROFILEEVENTS + "/:id", element: <ProtectedRoute><ProfileEvents /></ProtectedRoute> },
  { path: PROFILEPOSTS + "/:id", element: <ProtectedRoute><ProfilePost /></ProtectedRoute> },
  { path: COURSES, element: <ProtectedRoute><Courses /></ProtectedRoute> },
  { path: COURSES + "/:id", element: <ProtectedRoute><Courses /></ProtectedRoute> },
  { path: MENTORSHIP, element: <ProtectedRoute><Mentorship /></ProtectedRoute> },
  { path: MENTORSHIP + "/:id", element: <ProtectedRoute><Mentorship /></ProtectedRoute> },
  { path: CHAT, element: <ProtectedRoute><ChatModule /></ProtectedRoute> },
  { path: EDIT_PROFILE, element: <ProtectedRoute><EditProfileInfo /></ProtectedRoute> },
  { path: SETTINGMODULE + "/:id", element: <ProtectedRoute><SettingModule /></ProtectedRoute> },
  { path: WALLET, element: <ProtectedRoute><Wallet /></ProtectedRoute> },
  { path: payPalCallback, element: <ProtectedRoute><PayPalCallback /></ProtectedRoute> },
  { path: NOTIFICATIONS, element: <ProtectedRoute><Index /></ProtectedRoute> },
  { path: SEARCH, element: <ProtectedRoute><Search /></ProtectedRoute> },
  { path: EVENT_DETAILS + ":id", element: <ProtectedRoute><EventsDetails /></ProtectedRoute> },
  { path: "/event/:id?", element: <ProtectedRoute><EventsDetails /></ProtectedRoute> },
  { path: WEBINAR_PAGE_DETAILS + ":id", element: <ProtectedRoute><WebinarDetails /></ProtectedRoute> },
  { path: "/webinar/:id?", element: <ProtectedRoute><WebinarDetails /></ProtectedRoute> },
  { path: SESSION_PAGE_DETAILS + ":id", element: <ProtectedRoute><SessionDetails /></ProtectedRoute> },
  { path: "/session/:id?", element: <ProtectedRoute><SessionDetails /></ProtectedRoute> },
  { path: "/mentorship-session-details/:id?", element: <ProtectedRoute><MentorshipSessionDetails /></ProtectedRoute> },
  { path: "/mentorship-details/:id?", element: <ProtectedRoute><MentorshipSessionDetails /></ProtectedRoute> },
  { path: "/event-details/:id?", element: <ProtectedRoute><EventsDetails /></ProtectedRoute> },
  { path: "/webinar-details/:id?", element: <ProtectedRoute><WebinarDetails /></ProtectedRoute> },
  { path: "/session-details/:id?", element: <ProtectedRoute><SessionDetails /></ProtectedRoute> },
  { path: LIVE_WEBINARS, element: <ProtectedRoute><LiveWebinars /></ProtectedRoute> },
  { path: GROUPSETTING, element: <ProtectedRoute><GroupSettings /></ProtectedRoute> },
  { path: CONTESTS, element: <ProtectedRoute><Contest /></ProtectedRoute> },
  { path: CONTEST_LIST, element: <ProtectedRoute><ContestList /></ProtectedRoute> },
  { path: CONTEST_DETAILS + ":type", element: <ProtectedRoute><ContestDetail /></ProtectedRoute> },
  { path: CLINICAL_SESSIONS, element: <ProtectedRoute><ClinicalSessions /></ProtectedRoute> },
  { path: CLINICAL_SESSIONS_DETAILS + ":id", element: <ProtectedRoute><SessionDetails /></ProtectedRoute> },
  { path: POST_DETAILS + ":post_id", element: <ProtectedRoute><PostsDetails /></ProtectedRoute> },
  { path: WEBINAR_DETAILS + ":post_id", element: <PostsDetails /> },
  { path: CLINICAL_DETAILS + ":post_id", element: <PostsDetails /> },
  { path: CLINICAL_SESSION_DETAILS + ":post_id", element: <PostsDetails /> },
  { path: POLL_DETAILS + ":post_id", element: <PostsDetails /> },
  { path: COURSE_SHARED_POST + ":course_id", element: <CourseSharedPost /> },
  { path: EVENT_SHARED_POST + ":event_id", element: <EventSharedPost /> },
  { path: NEW_CONTEST, element: <ProtectedRoute><NewContest /></ProtectedRoute> },
  { path: SEE_ALL_TRENDING_PAGE, element: <ProtectedRoute><SeeAllCoursesPage type="trending" /></ProtectedRoute> },
  { path: SEE_ALL_FOLLOWING_DOCTOR_PAGE, element: <ProtectedRoute><SeeAllCoursesPage type="following" /></ProtectedRoute> },
  { path: SEE_ALL_POPULAR_COURSES_PAGE, element: <ProtectedRoute><SeeAllCoursesPage type="popular" /></ProtectedRoute> },
  { path: SEE_ALL_SUGGESTED_EVENTS, element: <ProtectedRoute><SeeAllSuggestedEvents /></ProtectedRoute> },
  { path: NEW_COURSE_DETAILS + ":course_id", element: <ProtectedRoute><NewCourseDetail /></ProtectedRoute> },
  { path: PAYPAL_PAYMENT, element: <ProtectedRoute><PaypalPaymentPage /></ProtectedRoute> },
  { path: COURSE_CHAPTER_DETAILS + ":course_id/:chapter_id?", element: <ProtectedRoute><CourseChapterDetails /></ProtectedRoute> },
  { path: Chapter_Quiz + ":quiz_id", element: <ProtectedRoute><ChapterQuiz /></ProtectedRoute> },
  { path: "/courses/filter", element: <ProtectedRoute><CourseSearchResultPage /></ProtectedRoute> },
  { path: NEW_COURSE_DETAIL_PAGE, element: <ProtectedRoute><NewCourseDetailPage /></ProtectedRoute> },
  { path: COURSE_COMMUNITY, element: <ProtectedRoute><CourseCommunity /></ProtectedRoute> },
  { path: COURSE_COMMUNITY_LIST, element: <ProtectedRoute><CourseCommunityList /></ProtectedRoute> },
  { path: DOCTOR_ACCOUNT, element: <ProtectedRoute><DoctorManageAccount /></ProtectedRoute> },
  { path: FACILITY_ACCOUNT, element: <ProtectedRoute><FacilityManageAccount /></ProtectedRoute> },
  { path: INDUSTRY_ACCOUNT, element: <ProtectedRoute><IndustryManageAccount /></ProtectedRoute> },
  { path: NEW_LOGIN, element: <LoggedInRoute><NewProfileLogin /></LoggedInRoute> },
  { path: NEW_SIGNUP, element: <LoggedInRoute><NewProfileLogin initialShowSignup /></LoggedInRoute> },
  { path: MANAGE_PROFILE, element: <ProtectedRoute><DoctorProfilePage /></ProtectedRoute> },
  { path: "/onboarding-Doctor", element: <ProtectedRoute><DoctorProfilePage /></ProtectedRoute> },
  { path: MANAGE_FACILITY, element: <ProtectedRoute><FacilityProfilePage /></ProtectedRoute> },
  { path: "/onboarding-Facility", element: <ProtectedRoute><FacilityProfilePage /></ProtectedRoute> },
  { path: MANAGE_INDUSTRY, element: <ProtectedRoute><IndustryProfilePage /></ProtectedRoute> },
  { path: "/onboarding-Industry", element: <ProtectedRoute><IndustryProfilePage /></ProtectedRoute> },
  { path: NEW_PROFILE_DOCTOR + "/:id?", element: <ProtectedRoute><NewProfile /></ProtectedRoute> },
  { path: NEW_PROFILE_FACILITY + "/:id?", element: <ProtectedRoute><NewFacilityProfile /></ProtectedRoute> },
  { path: NEW_PROFILE_INDUSTRY + "/:id?", element: <ProtectedRoute><NewIndustryProfile /></ProtectedRoute> },
  { path: "/waiting", element: <ProtectedRoute><WaitingScreen /></ProtectedRoute> },
  { path: "/again-verification", element: <ProtectedRoute><AgainVerification /></ProtectedRoute> },
  { path: "/account-reject", element: <ProtectedRoute><AccountReject /></ProtectedRoute> },
]);

export default Router;
